import * as pbi from '../../public/index.component'
import { AdminService } from '../admin.service';
declare var jquery: any;
declare var $: any;
@pbi.Component({
    selector: 'banner',
    templateUrl: './banner.component.html',
    styleUrls: [
        './banner.component.css',
    ]
})
export class BannerComponent {
    pb_func: pbi.PublicComponent = new pbi.PublicComponent();
    items: Object[];
    PageTitle: string = "Quản lý Banner";
    //#region Banner
    Title: string = "";
    ID: string = "-1";
    NodeID: string = "";
    Name: string = "";
    HinhAnh: string = this.pb_func.NotImage;
    FileHinhAnh: any = null;
    DelHinhAnh: string = "";
    Active: boolean = false;
    Action: string = "";
    LinkOrg: string = "";
    imageLoader: boolean = true;
    //#endregion Banner
    constructor(private adminService: AdminService, private router: pbi.Router) {
        adminService.openLoading0();
    }
    ngOnInit() {
        var this_sav = this;
        var this_sav = this;
        this_sav.pb_func.loadScript([
            'assets/global/scripts/datatable.js',
            'assets/global/plugins/datatables/datatables.min.js',
            'assets/global/plugins/datatables/plugins/bootstrap/datatables.bootstrap.js',
            'assets/global/plugins/jstree/dist/jstree.min.js',
            'assets/pages/scripts/ui-tree.min.js',
            'assets/global/plugins/jquery-inputmask/jquery.inputmask.bundle.min.js',
            'assets/global/plugins/bootstrap-tagsinput/bootstrap-tagsinput.js',
            'assets/src-noconflict/ace.js',
            'assets/more/script/fixHeightContent.js'
        ], 'banner', function () {
            this_sav.tableBanner();
            this_sav.TreeViewHinhAnh();
        });
    };

    tableBanner() {
        var this_sav = this;
        var url = this_sav.pb_func.getBaseUrl() + "api/Banner/load";
        var table = $('#datatable_ajax');
        
        var tbl = table.DataTable({
            "bProcessing": true,
            "bServerSide": true,
            "sAjaxSource": url,
            "bSort" : false,
            "fnServerData": function (sSource, aoData, fnCallback, oSettings) {
                oSettings.jqXHR = $.ajax({
                    "dataType": 'json',
                    "type": "POST",
                    "url": sSource,
                    "data": aoData,
                    "headers": { 'Authorization': this_sav.pb_func.getToken() },
                    "success": function(json) {
                        this_sav.items = json.aaData;
                        if (this_sav.items.length > 0) {
                            this_sav.LinkOrg = this_sav.items[0]["LinkOrg"];
                        }
                        fnCallback(json);
                    },
                });
            },
            "columns": [
                { "data": null },
                { "data": "Name", "className": "dt-center" },
                { "data": "Data", "className": "dt-center" },
                { "data": "Created", "className": "dt-center" },
                { "data": "Updated", "className": "dt-center" },
                { "data": "Active", "className": "dt-center" },
                { "data": "Action", "className": "dt-center" },
            ],
            "lengthMenu": [
                [5],
                [5]
            ],
            "pageLength": 5,
            "drawCallback": function (settings) {
                $('.EditBannerModal').off('click');
                $('.EditBannerModal').click(function () {
                    this_sav.EditBannerModal(this, $(this).attr('idsp'), $(this).attr('typesp'));
                });
                
                $('.EditHinhAnhModal').off('click');
                $('.EditHinhAnhModal').click(function () {
                    this_sav.EditHinhAnhModal(this, $(this).attr('idsp'), $(this).attr('typesp'));
                });

                $('.ActiveBannerModal').off('click');
                $('.ActiveBannerModal').click(function () {
                    this_sav.Active = $(this).prop('checked');
                    this_sav.ID = $(this).attr('idsp');
                    this_sav.UpdateBanner(this, $(this).attr('typesp'));
                });
            },
            "rowCallback": function (row, data, displayNum, displayIndex, dataIndex) {
                var page = this.fnPagingInfo().iPage;
                var length = this.fnPagingInfo().iLength;
                var index = (page * length + (displayIndex + 1));
                $('td:eq(0)', row).html(index);
            },
            "initComplete": function (settings, json) {
                this_sav.adminService.closeLoading(() => {

                });
            }
        });
    }

    //#region Modal
    EditBannerModal($event, ID: string, type: string) {
        var this_sav = this;
        var a = $event.currentTarget;
        if (type != 'add') {
            a = $event;
        }
        var tr = $(a).parent().parent().parent();
        this_sav.ID = ID;
        
        var editModal = $('#EditBannerModal');
        if (type == "add") {
            setTimeout(() => { editModal.find('input.autofocus').focus(); }, 500);
            this_sav.Name = "";
            this_sav.Title = "Thêm mới Banner";
        }
        else if (type == "edit") {
            setTimeout(() => { editModal.find('input.autofocus').focus(); }, 500);
            var row = this_sav.items.filter(function (item) {
                return item["ID"] == ID;
            })[0];
            this_sav.Name = row["Name"];
            this_sav.Title = `Sửa Banner "${this_sav.Name}"`;
        }
        else if (type == "del") {
            var row = this_sav.items.filter(function (item) {
                return item["ID"] == ID;
            })[0];
            this_sav.Name = row["Name"];
            this_sav.Title = `Xóa Banner "${this_sav.Name}"`;
        }
        this_sav.Action = type;
        this_sav.Active = false;
        $(a).next().click();
    }
    //#endregion Modal

    //#region Add, Edit, Del
    UpdateBanner($event, type: string) {
        var this_sav = this;
        var table = $('#datatable_ajax').DataTable();
        var editModal = $('#EditBannerModal');
        var a = $event.currentTarget;
        if(a == null)
            a = $event;

        this_sav.adminService.openLoading1();
        this_sav.pb_func.callAPI('api/Banner/Update', 'POST',
            {
                ID: this_sav.ID, Name: this_sav.Name,
                Active: this_sav.Active, Type: type
            },
            null, function (status, mess) {
                this_sav.adminService.closeLoading(function () { });
                var elemNotify = editModal.find('.notifyModal');
                if(type == "updateActive") {
                    elemNotify = $;
                    if (status == 0) {
                        var checked = $(a).prop('checked');
                        $(a).prop('checked', checked !== true);
                    }
                }

                if (status == 0) {
                    elemNotify.notify(mess.toString(), { globalPosition: 'bottom right', className: 'error' });
                }
                else {
                    table.ajax.reload(null, false);
                    elemNotify.notify(mess.toString(), { globalPosition: 'bottom right', className: 'success' });
                }
            });
    }

    DeleteBanner($event, type: string) {
        var this_sav = this;
        var table = $('#datatable_ajax').DataTable();
        this_sav.adminService.openLoading1();
        this_sav.pb_func.callAPI('api/Banner/Delete', 'POST', { ID: this_sav.ID }, null, function (status, mess) {
            this_sav.adminService.closeLoading(function () {
                if (status == 0) {
                    $.notify(mess, { globalPosition: 'bottom right', className: 'error' });
                }
                else {
                    table.ajax.reload(null, false);
                    $.notify(mess, { globalPosition: 'bottom right', className: 'success' });
                }
                $('#DelBannerModal .close').click();
            });
        });
    }
    //#endregion Add, Edit, Del

    //#region HinhAnh
    EditHinhAnhModal($event, ID: string, type: string) {
        var this_sav = this;
        var treeView = $('#treeViewHinhAnh');
        $('#LinktreeViewHinhAnh').prop('disabled', true);
        var a = $event;
        this_sav.adminService.openLoading1();
        this_sav.ID = ID;
        var row = this_sav.items.filter(function (item) {
            return item["ID"] == ID;
        })[0];
        this_sav.Name = row["Name"];
        this_sav.HinhAnh = this_sav.pb_func.NotImage;
        this_sav.NodeID = "";
        $(a).next().click();
        treeView.jstree(true).refresh();
    }

    TreeViewHinhAnh() {
        var this_sav = this;
        var treeView = $('#treeViewHinhAnh');
        var inputTreeView = $('#LinktreeViewHinhAnh');
        var fileTreeView = $('#FiletreeViewHinhAnh');
        var url = this_sav.pb_func.getBaseUrl() + "api/Banner/HinhAnh";
        this_sav.NodeID = "";
        treeView.jstree({
            "core": {
                "themes": {
                    "responsive": false
                },
                // so that create works
                "check_callback": true,
                'data': {
                    'url': function (node) {
                        return url;
                    },
                    'data': function (node) {
                        return { 'ID': this_sav.ID };
                    },
                    'type': 'POST',
                    'headers': { 'Authorization': this_sav.pb_func.getToken() },
                    'success': function () {
                        this_sav.imageLoader = false;
                        this_sav.adminService.closeLoading(function () { });
                    }
                }
            },
            "types": {
                "default": {
                    "icon": "fa fa-folder icon-state-warning icon-lg",
                    "max_depth": 1,
                },
                "file": {
                    "icon": "fa fa-file icon-state-warning icon-lg"
                }
            },
            "contextmenu":{
                'items' : function(node) {
                    var items = $.jstree.defaults.contextmenu.items();
                    items.ccp = false;
    
                    return items;
                }
            },
            "state": { "key": "demo3" },
            "plugins": ["contextmenu", "dnd", "state", "types"]
        });

        treeView.on('changed.jstree', function (e, data) {
            if (this_sav.HinhAnh !== "delete") {
                if (data.node != null) {
                    let id = data.node.id;
                    if(this_sav.NodeID == id)
                        return;
                    
                    this_sav.NodeID = id;

                    fileTreeView.val('');
                    this_sav.FileHinhAnh = null;
                    
                    if (id != 'notSelectNode') {
                        inputTreeView.prop('disabled', false);
                        var href = data.node.a_attr.href;
                        var image = data.node.a_attr.image;
                        inputTreeView.val(href);
                        if (image != null && image != '') {
                            this_sav.imageLoader = true;
                            this_sav.HinhAnh = this_sav.LinkOrg + image;
                        }
                        else {
                            this_sav.HinhAnh = this_sav.pb_func.NotImage;
                        }
                    }
                    else {
                        this_sav.HinhAnh = this_sav.pb_func.NotImage;
                        inputTreeView.val('');
                        inputTreeView.prop('disabled', true);
                    }
                }
            }
            else {
                this_sav.HinhAnh = this_sav.pb_func.NotImage;
                inputTreeView.click();
            }
        });

        treeView.on("delete_node.jstree", function (e, data) {
            this_sav.HinhAnh = "delete";
        });

        inputTreeView.focusout(function () {
            var nodes = treeView.jstree('get_selected', true);
            nodes[0].a_attr.href = $(this).val();
        });

        inputTreeView.keypress(function (e) {
            if (e.which == 13) {
                treeView.focus();
            }
        });
    }

    ChangeHinhAnh($event) {
        if ($('#LinktreeViewHinhAnh').prop('disabled') !== true) {
            var a = $event.currentTarget;
            $(a).find('input[type="file"]').click();
        }
        else {
            alert('Error');
        }
    }

    readHinhAnh($event) {
        var this_sav = this;
        var reader = new FileReader();
        reader.onload = function (ee) {
            this_sav.HinhAnh = reader.result.toString();
        };

        try {
            this_sav.FileHinhAnh = $event.currentTarget.files[0];
            reader.readAsDataURL(this_sav.FileHinhAnh);
        }
        catch (r) {
            this_sav.HinhAnh = this_sav.pb_func.NotImage;
        }
    }

    SaveHinhAnh($event) {
        var this_sav = this;
        var table = $('#datatable_ajax').DataTable();
        var treeView = $('#treeViewHinhAnh');
        var editModal = $('#EditHinhAnhModal');
        var nodes = treeView.jstree('get_selected', true);
        if (nodes.length > 0)
            this_sav.DelHinhAnh = nodes[0].a_attr.image;
        else
            this_sav.DelHinhAnh = "";

        if (this_sav.FileHinhAnh != null) {
            nodes[0].a_attr.image = 'NewImageLinkFor';
        }
        var v = treeView.jstree(true).get_json('#', { flat: true })
        v.splice(0, 1);

        let formData: FormData = new FormData();
        formData.append("ID", this_sav.ID);
        formData.append("HinhAnh", JSON.stringify(v));
        formData.append("DelHinhAnh", this_sav.DelHinhAnh);
        formData.append("FileHinhAnh", this_sav.FileHinhAnh);

        this_sav.pb_func.callAPI('api/Banner/UpdateHinhAnh', 'POST', formData, null,
            function (status, mess) {
                this_sav.adminService.closeLoading(function () { });
                if (status == 0) {
                    editModal.find('.notifyModal').notify(mess.toString(), { globalPosition: 'bottom right', className: 'error' });
                }
                else {
                    table.ajax.reload(null, false);
                    treeView.jstree(true).refresh();
                    editModal.find('.notifyModal').notify(mess.toString(), { globalPosition: 'bottom right', className: 'success' });
                }
            });
    }
    //#endregion HinhAnh
}


// WEBPACK FOOTER //
// ./src/app/admin/banner/banner.component.ts